module.exports = __webpack_public_path__ + "img/w3_check_light.d40d2b4f.png";